export interface RelativeTimeTranslations {
  justNow: string;
  minutesAgo: (count: number) => string;
  hoursAgo: (count: number) => string;
  daysAgo: (count: number) => string;
  weeksAgo: (count: number) => string;
  monthsAgo: (count: number) => string;
  yearsAgo: (count: number) => string;
}

export function formatRelativeTime(
  dateString: string,
  translations: RelativeTimeTranslations,
): string {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  if (diffSeconds < 60) return translations.justNow;
  if (diffMinutes < 60) return translations.minutesAgo(diffMinutes);
  if (diffHours < 24) return translations.hoursAgo(diffHours);
  if (diffDays < 7) return translations.daysAgo(diffDays);
  if (diffDays < 30) return translations.weeksAgo(diffWeeks);
  if (diffDays < 365) return translations.monthsAgo(diffMonths);
  return translations.yearsAgo(diffYears);
}
